import { createContext } from "react";

export interface TextConfig {
  bold: boolean;
  italic: boolean;
  underline: boolean;
}

interface AdditionaInfo {
  addition_page_display: number;
  addition_position_display: number | null;
  quiz_additions?: any[];
}

interface ContactFormInfo {
  form_design_type: number;
  form_title: string;
  form_title_config: TextConfig;
  form_description: string;
  form_description_config: TextConfig;
  messengers?: boolean;
  messengers_config?: { [key: string]: boolean };

  privacy_policy: boolean;
  privacy_policy_link: string;
}
interface ThanksPageInfo {
  thank_title: string;
  thank_title_config: TextConfig; //TODO:Not needs

  thank_description: string;
  thank_description_config: TextConfig;
  thank_button: boolean;
  thank_button_text: string;
  thank_link: string;
  thank_is_auto_redirect: boolean;
  thank_auto_redirect_link: string;
}

export interface SessionInfo {
  session?: string;
}
export interface QuizPublicInfo
  extends ContactFormInfo,
    ThanksPageInfo,
    AdditionaInfo,
    SessionInfo {
  id: number;
  title: string;
  title_config: TextConfig;
  description: string;
  description_config: TextConfig;
  design_type: number;
  button_style: number; //QuizBtnValue;
  button_color: string;
  button_text: string;
  button_text_color: string;
  button_text_config: TextConfig;
  background_color: string;
  text_color: string;
  image: string | null;
  project: number;
  language: number;
  font: number;
  progress_bar_style: number | null;
  currency: { id: number; title: string };

  //formData?: FormData;

  after_contacts: boolean;
  send_email: boolean;
  many_result: boolean;
  result_design_type: number;
  result_title: string;
  result_title_config: TextConfig;
  result_description: string;
  result_description_config: TextConfig;
  //formula?: { config: (string | number)[] };

  form_fields: any[];
  language_code: string;
  is_main_page_enabled: boolean;
}

// export type QuizContextType = {
//   value: QuizPublicInfo;
// };

export const QuizContext = createContext<QuizPublicInfo>({} as any);
